import { PropsWithChildren, ReactNode } from "react";
import { Link } from "react-router-dom";

import { ChevronRightSvg } from "@components/index";

export const MobileMenuItem = ({
  href,
  icon,
  rightIcon,
  notLink = false,
  children,
}: {
  href: string;
  icon: ReactNode;
  rightIcon?: ReactNode;
  notLink?: boolean;
} & PropsWithChildren) =>
  !notLink ? (
    <Link to={href} className="flex items-center justify-between">
      <div className="flex items-center gap-x-3">
        <div className="rounded-3xl bg-primary-108 p-3 text-primary-300">
          {icon}
        </div>
        {children}
      </div>
      <div className="text-black-54">{rightIcon || <ChevronRightSvg />}</div>
    </Link>
  ) : (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-x-3">
        <div className="rounded-3xl bg-primary-108 p-3 text-primary-300">
          {icon}
        </div>
        {children}
      </div>
      <div className="text-black-54">{rightIcon || <ChevronRightSvg />}</div>
    </div>
  );
